import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import {  } from "../actions/api"
import {  } from "../actions/localStates"
import { formatDate } from '../actions/helpers'

class RemovedOtherCertificatesView extends Component {
	constructor() {
		super();
		this.state = {

		};
	}

	componentDidMount() {
		var _this = this, state;
		var tempState = {};
		this.setState({showActions: []})

		function containsId (i) {
			if (_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.keyIdentifiers.length > 0) {
				if (!_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.keyIdentifiers.includes(i)) {
					return true
				} else {
					return false
				}
			} else {
				return true;
			}
			
		} 

		if (this.props.tokenList.tokenEnquire && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached !== null) {
			for (var i in this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos) {
				if (containsId(i)) {
					tempState[i] = false;
				}
			}
		}

		this.setState({showActions: tempState})
		this.setState({dropdownsSetted: true})
		state = tempState

		document.addEventListener('click', function (e) {
			if (e.target && e.target.id && state.hasOwnProperty(e.target.id)) {
				state[e.target.id] = true;
			} else {
				for (var key in state) {
				    state[key] = false
				}
			}

			_this.setState({showActions: state})
		});
	}

	componentWillUnmount () {
		document.removeEventListener('click', this);
	}

	_renderData() {
		var data = [], resData = [], _this = this;

		function containsId (id) {
			data = [];
			if (_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached !== null && _this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.keyIdentifiers.length > 0) {
				if (!_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.keyIdentifiers.includes(id)) {
					data.push(
						<div key={id}>
							<div style={{paddingLeft: "0px", paddingRight: "0px", marginBottom: "10px"}} className="table-border bg-color row col-lg-12 col-md-12 col-sm-12 col-xs-12">
								<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "left"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
									<div className="table-header">
										<label>{i18next.t("owner")}</label>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<label>
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subject.commonName
											}
										</label>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("drfou")
											}
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.drfou
											}
										</label>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("edrpou")
											}
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.edrpou
											}
										</label>
									</div>
								</div>
								<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
									<div className="table-header">
										<label>{i18next.t("appointment")}</label>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.keyUsage.indexOf("DIGITAL_SIGNATURE") > -1
												? i18next.t("DIGITAL_SIGNATURE")
												: null
											}
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.keyUsage.indexOf("KEY_AGREEMENT") > -1
												? i18next.t("KEY_AGREEMENT")
												: null
											}
										</label>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.isElectronicStamp !== undefined && _this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.isElectronicStamp === true
												? i18next.t("electronicStamp")
												: null
											}
										</label>
									</div>
								</div>
								<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<div className="table-header">
										<label>{i18next.t("key")}</label>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<div>
											<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
												{
													i18next.t("algorithm")
												}
												{
													_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subjectPublicKeyInfo.algorithm === "1.2.840.10045.2.1" ? i18next.t("ECDSA-256") : (_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subjectPublicKeyInfo.algorithm === "1.2.840.113549.1.1.1" ? i18next.t("RSA") : _this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subjectPublicKeyInfo.algorithm)
												}
											</label>
										</div>
										<div>
											<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
												{
													i18next.t("identifire")
												}
											</label>
											<div className="margin-left-5" style={{wordWrap: "break-word", fontSize: "10px", textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
												{
													id
												}
											</div>
										</div>
									</div>
								</div>
								<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
									<div className="table-header">
										<label>{i18next.t("certificate")}</label>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<div>
											<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
												{
													i18next.t("notBefore")
												}
												{
													_this.props.actions.formatDate(_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].notBefore)
												}
											</label>
										</div>
										<div>
											<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
												{
													i18next.t("notAfter")
												}
												{
													_this.props.actions.formatDate(_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].notAfter)
												}
											</label>
										</div>
										<div>
											<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
												{
													i18next.t("issuer")
												}
												{
													_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].issuer.commonName
												}
											</label>
										</div>
									</div>
								</div>
								<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-1 col-md-1 col-sm-12 col-xs-12">
									<div className="table-header min-heigth-33">
										<label></label>
									</div>
								</div>
							</div>
						</div>)
				}
				
			} else {
				data.push(
					<div key={id}>
						<div style={{paddingLeft: "0px", paddingRight: "0px", marginBottom: "10px"}} className="table-border bg-color row col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "left"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
								<div className="table-header">
									<label>{i18next.t("owner")}</label>
								</div>
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<label>
										{
											_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subject.commonName
										}
									</label>
									<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
										{
											i18next.t("drfou")
										}
										{
											_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.drfou
										}
									</label>
									<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
										{
											i18next.t("edrpou")
										}
										{
											_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.edrpou
										}
									</label>
								</div>
							</div>
							<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
								<div className="table-header">
									<label>{i18next.t("appointment")}</label>
								</div>
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
										{
											_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.keyUsage.indexOf("DIGITAL_SIGNATURE") > -1
											? i18next.t("DIGITAL_SIGNATURE")
											: null
										}
										{
											_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.keyUsage.indexOf("KEY_AGREEMENT") > -1
											? i18next.t("KEY_AGREEMENT")
											: null
										}
									</label>
									<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
										{
											_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.isElectronicStamp !== undefined && _this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].extensions.isElectronicStamp === true
											? i18next.t("electronicStamp")
											: null
										}
									</label>
								</div>
							</div>
							<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
								<div className="table-header">
									<label>{i18next.t("key")}</label>
								</div>
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("algorithm")
											}
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subjectPublicKeyInfo.algorithm === "1.2.840.10045.2.1" ? i18next.t("ECDSA-256") : (_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subjectPublicKeyInfo.algorithm === "1.2.840.113549.1.1.1" ? i18next.t("RSA") : _this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].subjectPublicKeyInfo.algorithm)
											}
										</label>
									</div>
									<div>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("identifire")
											}
										</label>
										<div className="margin-left-5" style={{wordWrap: "break-word", fontSize: "10px", textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												id
											}
										</div>
									</div>
								</div>
							</div>
							<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
								<div className="table-header">
									<label>{i18next.t("certificate")}</label>
								</div>
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("notBefore")
											}
											{
												_this.props.actions.formatDate(_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].notBefore)
											}
										</label>
									</div>
									<div>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("notAfter")
											}
											{
												_this.props.actions.formatDate(_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].notAfter)
											}
										</label>
									</div>
									<div>
										<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
											{
												i18next.t("issuer")
											}
											{
												_this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[id].issuer.commonName
											}
										</label>
									</div>
								</div>
							</div>
							<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-1 col-md-1 col-sm-12 col-xs-12">
								<div className="table-header min-heigth-33">
									<label></label>
								</div>
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
								</div>
							</div>
						</div>
					</div>)
			}
			return data;
		}

		if (this.props.tokenList.tokenEnquire.tokenContentDescriptorCached !== null && this.props.tokenList.tokenEnquire) {
			for (var id in this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos) {
				resData.push(containsId(id));
			}

			return resData;
		}
	}

	render() {
		return (
			<div>
				{
					this.props.tokenList.tokenEnquireSetted
					? <div style={{marginTop: "10px"}}>
				    	{
							this.state.showActions && Object.keys(this.state.showActions).length === 0 && this.state.showActions.constructor === Object
							? null
							: <label>{i18next.t("otherCertificates")}</label>
						}

							<div>
								{	
									this._renderData()
								}
							</div>
						</div>
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        login: state.loginReducer,
        tokenList: state.removedTokenListReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	formatDate
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RemovedOtherCertificatesView);